export class ISubscription {
  Id: number;
  Name: string;
  Description: string;
  Amount: number;
  IsFree: boolean;
  IsForAll: boolean;
  Order: number;
  CreatedDate: Date;
}
export class Subscription implements ISubscription {
  Id: number;
  Name: string;
  Description: string;
  Amount: number;
  IsFree: boolean;
  IsForAll: boolean;
  Order: number;
  CreatedDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/subscription.ts